module.exports = __webpack_public_path__ + "static/media/about.5fb538b9.png";